import React from 'react';
import { connect } from 'react-redux';
import DocumentTitle from 'react-document-title';

import Status from 'ui/Status';
import Post from 'ui/Post';
import { postBySlugSelector, fetchPostStatusSelector } from 'ducks/posts';




class PostScreen extends React.Component {

	render() {
		const { fetchStatus, post } = this.props;

		return (
			<div className="screen-wrap">
				{post && <DocumentTitle title={`${post.title} - Caleb Miller`} />}
				{!post && <Status asyncStatus={fetchStatus} pendingMessage="Loading Post" />}
				{post && <Post post={post} />}
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	fetchStatus: fetchPostStatusSelector(state),
	post: postBySlugSelector(state, ownProps.slug)
});

export default connect(mapStateToProps)(PostScreen);



// WEBPACK FOOTER //
// ./src/ui/screens/PostScreen.jsx